<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <zv-table :table="table" ref="dataTable">
          <div slot="ctrl-button">
            <el-button type="primary" @click="doAdd()">新增</el-button>
          </div>
        </zv-table>

        <zv-dialog
          width="400px"
          :title="isEdit ? '修改角色' : '新增角色'"
          :showDialog.sync="showFormDialog"
          @close-dialog="closeFormDialog"
        >
          <div slot="content">
            <el-form
              ref="myForm"
              label-width="140px"
              :model="formData"
              :rules="formRules"
              status-icon
            >
              <el-form-item label="角色名称：" prop="rolename">
                <el-input v-model="formData.rolename" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="btns">
            <el-button @click="showFormDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm">确定</el-button>
          </div>
        </zv-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import addFormMixin from "@/mixins/addFormMixin";
export default {
  name: "AppList",
  mixins: [addFormMixin],
  components: {
  },
  data() {
    let vm = this;
    return {
      table: {
        api: this.$api.getRoleList,
        query: {

        },
        searchData: [
          {
            // type: "input",
            // model: "rolename",
            // placeholder: "角色名称"
          }
        ],
        columns: [
          {
            title: "角色名称",
            key: "rolename",
            minWidth:"150",
            showTooltip: true
          },
          // {
          //   title: "操作人",
          //   key: "last_admin_username",
          //   minWidth: "60",
          //   render(h, ctx) {
          //     let status = ctx.row.last_admin_username;
          //     let statusText;
          //     if (status == "") {
          //       statusText = "--";
          //     } else {
          //       statusText = status;
          //     }
          //     return h("span", statusText);
          //   }
          // },
          {
            title: "操作",
            fixed: "right",
            minWidth:"150",
            render(h, ctx) {
              const editBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {
                    click: vm.doEdit.bind(this, ctx.row)
                  }
                },
                "修改"
              );

              const delBtn = h(
                "el-button",
                {
                  attrs: {
                    type: "text"
                  },
                  on: {

                    click: vm.doDelete.bind(this, ctx.row.id)
                  }
                },

                "删除"

              );

              let arr = [];
              arr.push(editBtn);

              arr.push(delBtn);

              return h("span", arr);
            }
          }
        ]
      },
      formDataOri: {
        app_name: ''
      },
      formRules: {
        app_name: [{
          required: true,
          message: "角色名称不能为空",
          trigger: "blur"
        }]
      },
      adddApi: null,
      editApi: null,
      deleteApi: null,
      addSuccessMsg: '添加角色成功',
      editSuccessMsg: '编辑角色成功',
      deleteSuccessMsg: '删除角色成功'
    };
  },

  computed: {

  },

  methods: {
    beforeValidate() {
      this.$message('接口待开发...')
    }
  },

  created() {
  },

  mounted() {

  },
  beforeDestroy() {

  }
};
</script>

<style lang="less" scoped>

</style>
